import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../../hooks/useApi";
import api from "../../../utils/api";
import "./Categories.scss";

const Categories = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, loading, refetch } = useApi(() => api.getAdminCategories(), []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await api.deleteCategory(id);
        refetch();
      } catch (error) {
        console.error("Error deleting category:", error);
        alert("Failed to delete category");
      }
    }
  };

  const categories = data?.categories || [];
  const filteredCategories = categories.filter((category) =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Organize categories by parent/child
  const parentCategories = filteredCategories.filter(cat => !cat.parentId);
  const childCategories = filteredCategories.filter(cat => cat.parentId);

  return (
    <div className="admin-categories">
      <div className="categories-header">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search categories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <Link to="/admin/categories/new" className="btn-primary">
          Add New Category
        </Link>
      </div>

      {loading ? (
        <div className="loading">Loading categories...</div>
      ) : (
        <div className="categories-table">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Type</th>
                <th>Slug</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCategories.length === 0 ? (
                <tr>
                  <td colSpan="6" className="empty-state">
                    No categories found
                  </td>
                </tr>
              ) : (
                <>
                  {parentCategories.map((category) => (
                    <React.Fragment key={category.id}>
                      <tr className="parent-category">
                        <td>{category.categoryId}</td>
                        <td><strong>{category.name}</strong></td>
                        <td><span className="badge-primary">Category</span></td>
                        <td>{category.slug}</td>
                        <td>{category.description || "-"}</td>
                        <td>
                          <div className="action-buttons">
                            <Link
                              to={`/admin/categories/${category.id}/edit`}
                              className="btn-edit"
                            >
                              Edit
                            </Link>
                            <button
                              onClick={() => handleDelete(category.id)}
                              className="btn-delete"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                      {childCategories
                        .filter(child => child.parentId === category.id)
                        .map((subcategory) => (
                          <tr key={subcategory.id} className="child-category">
                            <td>{subcategory.categoryId}</td>
                            <td>└─ {subcategory.name}</td>
                            <td><span className="badge-secondary">Subcategory</span></td>
                            <td>{subcategory.slug}</td>
                            <td>{subcategory.description || "-"}</td>
                            <td>
                              <div className="action-buttons">
                                <Link
                                  to={`/admin/categories/${subcategory.id}/edit`}
                                  className="btn-edit"
                                >
                                  Edit
                                </Link>
                                <button
                                  onClick={() => handleDelete(subcategory.id)}
                                  className="btn-delete"
                                >
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  ))}
                  {childCategories.filter(child => 
                    !parentCategories.find(p => p.id === child.parentId)
                  ).map((category) => (
                    <tr key={category.id} className="child-category">
                      <td>{category.categoryId}</td>
                      <td>└─ {category.name}</td>
                      <td><span className="badge-secondary">Subcategory</span></td>
                      <td>{category.slug}</td>
                      <td>{category.description || "-"}</td>
                      <td>
                        <div className="action-buttons">
                          <Link
                            to={`/admin/categories/${category.id}/edit`}
                            className="btn-edit"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() => handleDelete(category.id)}
                            className="btn-delete"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Categories;
